export const SET_EDIT_PAYMENT_INFORMATION = 'finishPartnerOrder/SET_EDIT_PAYMENT_INFORMATION';
export const SET_SHOW_AVAILABILITY = 'finishPartnerOrder/SET_SHOW_AVAILABILITY';
export const TOGGLE_MODAL = 'finishPartnerOrder/TOGGLE_MODAL';
export const BOOK = 'finishPartnerOrder/BOOK';
